import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon, ExternalLinkIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function TemplateCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const projects = [{
    title: 'Debt Rescue',
    category: 'Financial Services / Business Solutions',
    quote: 'Professional platform handling sensitive financial matters with complete discretion',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1c8vq2ajwLeXwihGnzEfYF/image.png',
    link: 'https://debtrescue.co.uk'
  }, {
    title: 'ooOhMy.co.uk',
    category: 'E-commerce / Fashion',
    quote: 'Increased our online sales by 45% in the first month',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pQKeoA3T9GzSKJQNGTdgoz/websites_1_-_ooOhmy.co.uk.jpg',
    link: 'https://ooohmy.co.uk'
  }, {
    title: 'Northampton Driving School',
    category: 'Education / Services',
    quote: 'Bookings up 60% since the new website launch',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/d5GzTyf2oC8ykFDj3X9wmi/Website_3_-_northamptondrivingschool.co.uk.jpg',
    link: 'https://northamptondrivingschool.co.uk'
  }, {
    title: 'Medicolegal Partners',
    category: 'Healthcare / Legal',
    quote: 'Professional site that perfectly represents our brand',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4kYo3C4gd9QjfCrgk7a12h/Website_2_-_medicolegal-psychiatry.co.uk.jpg',
    link: 'https://medicolegal-psychiatry.co.uk'
  }, {
    title: 'SureFix.it',
    category: 'Home Services / Repair',
    quote: 'Lead generation increased 75% year on year',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2mYs5H4cmXngmP57UGoyEE/Website_4_-_surefix.it.com.jpg',
    link: 'https://surefix.it.com'
  }, {
    title: 'AxisCare.it',
    category: 'Home Services / Repair',
    quote: 'ROI on website in just 2 months. Incredible!',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wqw4YWP28GPXqhAPXrrgAj/Website_5_-_axiscare.it.com.jpg',
    link: 'https://axiscare.it.com'
  }];
  const nextSlide = () => {
    setCurrentIndex(prevIndex => prevIndex === projects.length - 1 ? 0 : prevIndex + 1);
  };
  const prevSlide = () => {
    setCurrentIndex(prevIndex => prevIndex === 0 ? projects.length - 1 : prevIndex - 1);
  };
  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };
  return <section className="py-12 md:py-16 bg-[#1E293B] relative overflow-hidden" data-id="element-505">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-506">
        <div className="max-w-7xl mx-auto" data-id="element-507">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-center mb-12" data-id="element-508">
            <span className="inline-block px-3 py-1 bg-[#0DC3DC]/20 text-[#0DC3DC] rounded-full text-sm font-medium mb-4" data-id="element-509">
              Our Work
            </span>
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white" data-id="element-510">
              Portfolio of Real Client Projects
            </h2>
            <p className="text-lg text-white/90 max-w-3xl mx-auto" data-id="element-511">
              Explore our latest work across various industries. Each project
              represents our commitment to creating beautiful, functional
              websites that deliver measurable results.
            </p>
          </motion.div>
          <div className="relative" data-id="element-512">
            {/* Carousel Container */}
            <div className="relative h-[600px] md:h-[500px]" data-id="element-513">
              <AnimatePresence mode="wait" data-id="element-514">
                <motion.div key={currentIndex} initial={{
                opacity: 0,
                x: 100
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: -100
              }} transition={{
                duration: 0.5
              }} className="absolute inset-0" data-id="element-515">
                  <div className="bg-white dark:bg-[#212C34] rounded-xl overflow-hidden shadow-xl h-full flex flex-col md:flex-row" data-id="element-516">
                    {/* Image Section */}
                    <div className="md:w-1/2 h-64 md:h-full relative" data-id="element-517">
                      <img src={projects[currentIndex].image} alt={`${projects[currentIndex].title} website homepage - Bright Pixxel Studios portfolio project`} className="w-full h-full object-cover object-top" data-id="element-518" />
                      <div className="absolute top-4 left-4" data-id="element-519">
                        <span className="bg-white/90 dark:bg-black/70 px-3 py-1 rounded-full text-sm font-medium" data-id="element-520">
                          {projects[currentIndex].category}
                        </span>
                      </div>
                    </div>
                    {/* Content Section */}
                    <div className="md:w-1/2 p-8 md:p-12 flex flex-col justify-center" data-id="element-521">
                      <h3 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-522">
                        {projects[currentIndex].title}
                      </h3>
                      <p className="text-lg text-gray-600 dark:text-gray-300 italic mb-8" data-id="element-523">
                        "{projects[currentIndex].quote}"
                      </p>
                      <div className="flex flex-col sm:flex-row gap-4" data-id="element-524">
                        <a href={projects[currentIndex].link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-[#0DC3DC] hover:bg-[#0DC3DC]/90 text-white px-6 py-3 rounded-lg font-medium transition-colors" data-id="element-525">
                          <span data-id="element-526">Visit Website</span>
                          <ExternalLinkIcon size={16} className="ml-2" data-id="element-527" />
                        </a>
                        <Link to="/portfolio" className="inline-flex items-center justify-center border-2 border-[#0DC3DC] text-[#0DC3DC] hover:bg-[#0DC3DC] hover:text-white px-6 py-3 rounded-lg font-medium transition-colors" data-id="element-528">
                          View Full Portfolio
                        </Link>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>
            {/* Navigation Arrows */}
            <button onClick={() => setCurrentIndex(prevIndex => prevIndex === 0 ? projects.length - 1 : prevIndex - 1)} className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 dark:bg-black/70 p-3 rounded-full shadow-lg hover:bg-white dark:hover:bg-black transition-colors z-10" aria-label="Previous project" data-id="element-529">
              <ChevronLeftIcon size={24} data-id="element-530" />
            </button>
            <button onClick={() => setCurrentIndex(prevIndex => prevIndex === projects.length - 1 ? 0 : prevIndex + 1)} className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 dark:bg-black/70 p-3 rounded-full shadow-lg hover:bg-white dark:hover:bg-black transition-colors z-10" aria-label="Next project" data-id="element-531">
              <ChevronRightIcon size={24} data-id="element-532" />
            </button>
          </div>
          {/* Dots Navigation */}
          <div className="flex justify-center gap-2 mt-8" data-id="element-533">
            {projects.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`w-3 h-3 rounded-full transition-all ${index === currentIndex ? 'bg-[#0DC3DC] w-8' : 'bg-white/30 hover:bg-white/50'}`} aria-label={`Go to project ${index + 1}`} data-id="element-534" />)}
          </div>
          {/* View All Link */}
          <div className="text-center mt-8" data-id="element-535">
            <Link to="/portfolio" className="inline-flex items-center text-[#0DC3DC] hover:text-[#0DC3DC]/80 font-medium text-lg" data-id="element-536">
              <span data-id="element-537">View All Projects</span>
              <ChevronRightIcon size={20} className="ml-1" data-id="element-538" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}